import type { KeyboardEventHandler } from 'react'

import { FormField } from '@runtime/components/ui/Form'
import PasswordToggleIcon from '@runtime/features/profile/auth/fields/PasswordToggleIcon'

import styles from '@runtime/features/profile/auth/fields/PasswordField.module.scss'

type PasswordFieldProps = {
  value: string
  visible: boolean
  placeholder: string
  disabled: boolean
  showLabel: string
  hideLabel: string
  onChange: (value: string) => void
  onToggleVisibility: () => void
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>
}

export default function PasswordField({
  value,
  visible,
  placeholder,
  disabled,
  showLabel,
  hideLabel,
  onChange,
  onToggleVisibility,
  onKeyDown,
}: PasswordFieldProps) {
  const toggleLabel = visible ? hideLabel : showLabel

  return (
    <div className={styles.passwordField}>
      <FormField
        round
        className={styles.passwordInput}
        data-testid="login-password-input"
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        onKeyDown={onKeyDown}
      />
      <button
        type="button"
        className={styles.passwordToggle}
        data-testid="login-password-toggle"
        onClick={onToggleVisibility}
        aria-label={toggleLabel}
        aria-pressed={visible}
        title={toggleLabel}
        disabled={disabled}
      >
        <PasswordToggleIcon visible={visible} />
      </button>
    </div>
  )
}
